import i18n from 'i18next';

export const HEADER_LABELS = {
  TIME_STAMP: i18n.t('components.vehicleAdjustmentDialog.labels.logTableHeader.timestamp'),
  USER: i18n.t('components.vehicleAdjustmentDialog.labels.logTableHeader.user'),
  CHOSEN_VALUES: i18n.t('components.vehicleAdjustmentDialog.labels.logTableHeader.chosenValues'),
};
